var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotiFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79057 16.5C8.59057 16.5 8.39057 16.4126 8.29057 16.3252C8.14057 16.1941 8.09057 16.0629 8.09057 15.8881V11.2552C8.09057 11.0367 7.99057 10.8182 7.84057 10.6434L3.14057 5.00524C2.99057 4.83042 2.94057 4.56818 3.09057 4.34965C3.19057 4.13112 3.44057 4 3.74057 4H16.5406C16.8406 4 17.0906 4.13112 17.1906 4.34965C17.3406 4.56818 17.2906 4.83042 17.1406 5.00524L12.4406 10.6434C12.2906 10.8182 12.1906 11.0367 12.1906 11.2552V14.9703C12.1906 15.2325 11.9906 15.4948 11.6906 15.5822L9.09057 16.4563C8.99057 16.4563 8.89057 16.5 8.79057 16.5ZM8.64057 10.1189C8.94057 10.4248 9.09057 10.8182 9.09057 11.2552V15.4948L11.1906 14.7955V11.2115C11.1906 10.8182 11.3406 10.4248 11.6406 10.0752L15.9906 4.87413H4.24057L8.64057 10.1189Z",
    fill: "#00CBAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotiFilter);
export default __webpack_public_path__ + "static/media/noti-filter.3d7f7b72cd9acc37c8272e562aed6136.svg";
export { ForwardRef as ReactComponent };